import * as React from 'react'
import { SelectSeeker } from 'ui-seeker/core'

const OPTIONS = [
    { value: '1-0', label: "1 adult 0 kids" },
    { value: '1-1', label: "1 adult 1 kid" },
    { value: '1-2', label: "1 adult 2 kids" },
    { value: '2-0', label: "2 adults 0 kids" },
    { value: '2-1', label: "2 adults 1 kid" },
    { value: '2-2', label: "2 adults 2 kids" },
    { value: '3-0', label: "3 adults 0 kids" },
    { value: '3-1', label: "3 adults 1 kid" },
    { value: '4-0', label: "4 adults 0 kids" },
    { value: '5-0', label: "5 adults 0 kids" },
    { value: '6-0', label: "6 adults 0 kids" }
]

export default function SelectPaxStatic({...props}) {
    const myProps = {
        placeholder: 'All occupations',
        firstSelect: true, 
        isClearable: true, 
        options: OPTIONS,
        icon: {icon: 'user'},
        isMulti: false,
        ...props
    }

    return <SelectSeeker {...myProps} />
}